import { Box, Typography, Checkbox, Collapse } from "@material-ui/core";
import { WithTranslation, withTranslation } from "react-i18next";
import { StatusReason } from "../../../../../../rest/properties/model/Property";
import { SenseProductType } from "../../../../../../rest/sense/model/SenseDevice";
import { SECONDARY_COLOR } from "../../../../../../ui/theme/createMaterialTheme";
import {
  SMALL_SPACING,
  LARGE_SPACING,
  DEFAULT_SPACING,
} from "../../../../../../ui/theme/dimensions";
import ProCheckFilterCheckbox from "./ProCheckFilterCheckbox";

interface ExternalProps {
  checkboxState: [SenseProductType, Set<StatusReason>] | undefined;
  deviceType: SenseProductType;
  onCheckChanged: (
    deviceFilters: [SenseProductType, Set<StatusReason>] | undefined
  ) => void;
}

type Props = ExternalProps & WithTranslation;

const ProCheckFilterBox = (props: Props) => {
  const handleHeaderCheckboxChange = (checked: boolean) => {
    let newSet: Set<StatusReason> = new Set<StatusReason>();

    if (!checked) {
      newSet = new Set<StatusReason>([]);
      props.onCheckChanged([props.deviceType, newSet]);
    } else {
      props.onCheckChanged(undefined);
    }
  };

  const handleCheckboxChange = (status: StatusReason, checked: boolean) => {
    let newStatuses = new Set(props.checkboxState?.[1]);

    if (checked) {
      newStatuses.add(status);
    } else {
      newStatuses.delete(status);
    }

    // Don't submit if nothing's changed.
    if (props.checkboxState?.[1] !== newStatuses) {
      props.onCheckChanged([props.deviceType, newStatuses]);
    }
  };

  return (
    <Box display="flex" flexDirection="column" marginY={SMALL_SPACING}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        marginRight={SMALL_SPACING}
        style={{ marginRight: SMALL_SPACING }}
      >
        <Box display="flex" alignItems="center">
          <Typography style={{ width: 110 }}>
            {props.t(`senseDeviceNames.${props.deviceType}`)}
          </Typography>
          <Box width={LARGE_SPACING + 14} />
        </Box>
        <Checkbox
          style={{ marginLeft: "11px" }}
          checked={props.checkboxState?.[0] === props.deviceType}
          onChange={(e, checked) => handleHeaderCheckboxChange(!checked)}
        />
      </Box>
      <Box display="flex" flexDirection="row" justifyContent="space-between">
        <Box
          display="flex"
          flexDirection="column"
          width={DEFAULT_SPACING}
          borderRadius={90}
          style={{
            backgroundColor: SECONDARY_COLOR,
          }}
        />
        <Box display="flex" flexDirection="column">
          <Collapse in={props.checkboxState?.[0] === props.deviceType}>
            <ProCheckFilterCheckbox
              status={"test_passed"}
              isChecked={
                props.checkboxState
                  ? (props.checkboxState[1] as Set<StatusReason>).has(
                      "test_passed" as StatusReason
                    )
                  : false
              }
              onCheckChanged={handleCheckboxChange}
            />
            <ProCheckFilterCheckbox
              status={"test_failed"}
              isChecked={
                props.checkboxState
                  ? (props.checkboxState[1] as Set<StatusReason>).has(
                      "test_failed" as StatusReason
                    )
                  : false
              }
              onCheckChanged={handleCheckboxChange}
            />
          </Collapse>
        </Box>
      </Box>
    </Box>
  );
};

export default withTranslation()(ProCheckFilterBox);
